/* 一覧画面 テーブル */
import React, { memo } from 'react';
import { Grid, _ } from 'gridjs-react';
import { project_list_staff_read_index_not_no as read_index_not_no } from '../Const';
import { project_list_staff_read_index_no as read_index_no } from '../Const';
import { project_list_staff_read_index_se as read_index_se } from '../Const';
var ResultList = function (_a) {
    var projects = _a.projects, config = _a.config, handleClick = _a.handleClick, handleRowChange = _a.handleRowChange, t = _a.t, handleChangeLimit = _a.handleChangeLimit, display_count = _a.display_count, row_selection = _a.row_selection, is_no_user = _a.is_no_user, is_se = _a.is_se, is_se_no = _a.is_se_no;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "result-list", className: "row my-2" },
            React.createElement("div", { className: "col-md-12" },
                React.createElement("span", { className: "search-criteria-head small" }, t('表示件数')),
                React.createElement("select", { name: t('表示件数'), className: "search-form-input small", onChange: handleChangeLimit, value: display_count }, config.display_list_number.map(function (num, index) {
                    return (React.createElement("option", { key: index, value: num }, num));
                })))),
        is_no_user ? (React.createElement(Grid, { data: projects, columns: [
                {
                    id: 'my-checkbox',
                    name: '',
                    formatter: function (cell, row) {
                        return _(React.createElement("input", { className: "row-selection", type: "checkbox", value: "" + row.cells[read_index_no.reception_cd].data, key: "" + row.cells[read_index_no.reception_cd].data, onChange: function () {
                                return handleRowChange(String(row.cells[read_index_no.reception_cd].data));
                            }, checked: row_selection[String(row.cells[read_index_no.reception_cd].data)] }));
                    },
                    width: '10px',
                },
                {
                    id: 'warranty-no',
                    name: _(React.createElement(React.Fragment, null, t('保証No.'))),
                    formatter: function (cell, row) {
                        if (!config.disabled_project_detail_status.includes(Number(row.cells[read_index_no.status].data))) {
                            return _(React.createElement("a", { className: "link-text", href: "" + location.origin + process.env.MIX_MOCK_URL + "/reception/" + row.cells[read_index_no.reception_cd].data + "/" + row.cells[read_index_no.reception_id].data, onClick: function (event) {
                                    return handleClick(event, String(row.cells[read_index_no.reception_id].data), String(row.cells[read_index_no.reception_cd].data), Number(row.cells[read_index_no.status].data));
                                } }, row.cells[read_index_no.reception_cd].data));
                        }
                        else {
                            return _(React.createElement(React.Fragment, null, row.cells[read_index_no.reception_cd].data));
                        }
                    },
                    width: '160px',
                },
                (is_se && !is_se_no) && {
                    id: 'local-data',
                    name: _(React.createElement(React.Fragment, null, t('ローカルデータ'))),
                    width: '130px',
                },
                {
                    id: 'watch_status',
                    name: _(React.createElement(React.Fragment, null, t('状態'))),
                    width: '140px',
                },
                {
                    id: 'upload_date_by_manufacturer',
                    name: _(React.createElement(React.Fragment, null, t('製造データ送品日'))),
                    width: '200px',
                },
                {
                    id: 'brand',
                    name: _(React.createElement(React.Fragment, null, t('ブランド'))),
                    width: '90px',
                },
                {
                    id: 'part-number',
                    name: _(React.createElement(React.Fragment, null, t('品番'))),
                    width: '140px',
                },
                {
                    id: 'caliber-number',
                    name: _(React.createElement(React.Fragment, null, t(is_se ? 'キャリバーNo.' : 'キャリバー番号'))),
                    width: '110px',
                },
                {
                    id: 'case-number',
                    name: _(React.createElement(React.Fragment, null, t(is_se ? 'ケースNo.' : 'ケース番号'))),
                    width: '100px',
                },
                {
                    id: 'serial-number',
                    name: _(React.createElement(React.Fragment, null, t('製造番号'))),
                    width: '140px',
                },
                {
                    id: 'serial-number(after-replacement)',
                    name: _(React.createElement(React.Fragment, null, t('製造番号（裏蓋交換後）'))),
                    width: '230px',
                },
                {
                    id: 'dc_shipping_date',
                    name: _(React.createElement(React.Fragment, null, t('DC出荷日'))),
                    width: '140px',
                },
                {
                    id: 'd_code_1',
                    name: _(React.createElement(React.Fragment, null, t(is_se ? '出荷先Dコード' : '出荷先Dコード１'))),
                    width: '140px',
                },
                {
                    id: 'd_code_1',
                    name: _(React.createElement(React.Fragment, null, t(is_se ? 'Dコード発送日' : 'Dコード1発送日'))),
                    width: '140px',
                },
                {
                    id: 'd_code_2',
                    name: _(React.createElement(React.Fragment, null, t('出荷先Dコード２'))),
                    width: '140px',
                    hidden: is_se,
                },
                {
                    id: 'd_code_1',
                    name: _(React.createElement(React.Fragment, null, t('Dコード2発送日'))),
                    width: '140px',
                    hidden: is_se,
                },
                {
                    id: 'd_code_3',
                    name: _(React.createElement(React.Fragment, null, t('出荷先Dコード３'))),
                    width: '140px',
                    hidden: is_se,
                },
                {
                    id: 'd_code_1',
                    name: _(React.createElement(React.Fragment, null, t('Dコード3発送日'))),
                    width: '170px',
                    hidden: is_se,
                },
                {
                    id: 'account_code',
                    name: _(React.createElement(React.Fragment, null, t('出荷先販売店コード'))),
                    width: '140px',
                },
                {
                    id: 'retailer-code',
                    name: _(React.createElement(React.Fragment, null, t(is_se ? '販売店コード' : '実販売店コード'))),
                    width: '140px',
                },
                {
                    id: 'retailer-name',
                    name: _(React.createElement(React.Fragment, null, t('販売店名'))),
                    width: '140px',
                },
                {
                    id: 'retailer-country',
                    name: _(React.createElement(React.Fragment, null, t('販売店国'))),
                    width: '140px',
                },
                {
                    id: 'person_in_charge_at_retailer',
                    name: _(React.createElement(React.Fragment, null, t('実販売店のご担当者'))),
                    width: '190px',
                },
                {
                    id: 'date_of_purchase',
                    name: _(React.createElement(React.Fragment, null, t('お買い上げ日'))),
                    width: '140px',
                },
                {
                    id: 'date_of_purchase',
                    name: _(React.createElement(React.Fragment, null, t('社販区分'))),
                    width: '140px',
                },
                {
                    id: 'date_of_purchase',
                    name: _(React.createElement(React.Fragment, null, t('社販日'))),
                    width: '140px',
                },
                {
                    id: 'date_of_purchase',
                    name: _(React.createElement(React.Fragment, null, t('備考'))),
                    width: '140px',
                },
                {
                    id: 'date_of_purchase_confirmation',
                    name: _(React.createElement(React.Fragment, null, t('購入確認日'))),
                    width: '200px',
                },
                {
                    id: 'validity_of_warranty',
                    name: _(React.createElement(React.Fragment, null, t('保証（有効・無効）'))),
                    width: '140px',
                },
                {
                    id: 'warranty_period (● years)',
                    name: _(React.createElement(React.Fragment, null, t('保証期間（●年）'))),
                    width: '180px',
                },
                {
                    id: 'warranty_start_date',
                    name: _(React.createElement(React.Fragment, null, t('保証開始日'))),
                    width: '140px',
                },
                {
                    id: 'warranty_end_date',
                    name: _(React.createElement(React.Fragment, null, t('保証終了日'))),
                    width: '140px',
                },
                {
                    id: 'country/area/region',
                    name: _(React.createElement(React.Fragment, null, t('居住国'))),
                    width: '140px',
                },
                // 以下は画面に表示しないデータ（カラム）
                {
                    id: 'id',
                    hidden: true,
                },
                {
                    id: 'status',
                    hidden: true,
                },
            ], search: false, sort: true, pagination: {
                enabled: true,
                limit: display_count,
            }, fixedHeader: true, height: "600px" })) : (React.createElement(Grid, { data: projects, columns: [
                {
                    id: 'my-checkbox',
                    name: '',
                    formatter: function (cell, row) {
                        return _(React.createElement("input", { className: "row-selection", type: "checkbox", value: "" + row.cells[(is_se && !is_se_no) ? read_index_se.reception_cd : read_index_not_no.reception_cd]
                                .data, key: "" + row.cells[(is_se && !is_se_no) ? read_index_se.reception_cd : read_index_not_no.reception_cd]
                                .data, onChange: function () {
                                return handleRowChange(String(row.cells[(is_se && !is_se_no) ? read_index_se.reception_cd : read_index_not_no.reception_cd].data));
                            }, checked: row_selection[String(row.cells[(is_se && !is_se_no) ? read_index_se.reception_cd : read_index_not_no.reception_cd].data)] }));
                    },
                    width: '10px',
                },
                {
                    id: 'warranty-no',
                    name: _(React.createElement(React.Fragment, null, t('保証No.'))),
                    formatter: function (cell, row) {
                        if (!config.disabled_project_detail_status.includes(Number(row.cells[(is_se && !is_se_no) ? read_index_se.status : read_index_not_no.status].data))) {
                            return _(React.createElement("a", { className: "link-text", href: "" + location.origin + process.env.MIX_MOCK_URL + "/reception/" + row.cells[(is_se && !is_se_no) ? read_index_se.reception_cd : read_index_not_no.reception_cd].data + "/" + row.cells[(is_se && !is_se_no) ? read_index_se.reception_id : read_index_not_no.reception_id].data, onClick: function (event) {
                                    return handleClick(event, String(row.cells[(is_se && !is_se_no) ? read_index_se.reception_id : read_index_not_no.reception_id].data), String(row.cells[(is_se && !is_se_no) ? read_index_se.reception_cd : read_index_not_no.reception_cd].data), Number(row.cells[(is_se && !is_se_no) ? read_index_se.status : read_index_not_no.status].data));
                                } }, row.cells[(is_se && !is_se_no) ? read_index_se.reception_cd : read_index_not_no.reception_cd].data));
                        }
                        else {
                            return _(React.createElement(React.Fragment, null, row.cells[(is_se && !is_se_no) ? read_index_se.reception_cd : read_index_not_no.reception_cd].data));
                        }
                    },
                    width: '130px',
                },
                (is_se && !is_se_no) && {
                    id: 'local-data',
                    name: _(React.createElement(React.Fragment, null, t('ローカルデータ'))),
                    width: '130px',
                },
                {
                    id: 'state',
                    name: _(React.createElement(React.Fragment, null, t(is_se ? 'ステータス' : '状態'))),
                    width: '130px',
                },
                {
                    id: 'brand',
                    name: _(React.createElement(React.Fragment, null, t('ブランド'))),
                    width: '90px',
                },
                {
                    id: 'part-number',
                    name: _(React.createElement(React.Fragment, null, t('品番'))),
                    width: '140px',
                },
                {
                    id: 'caliber-number',
                    name: _(React.createElement(React.Fragment, null, t(is_se ? 'キャリバーNo.' : 'キャリバー番号'))),
                    width: '110px',
                },
                {
                    id: 'case-number',
                    name: _(React.createElement(React.Fragment, null, t(is_se ? 'ケースNo.' : 'ケース番号'))),
                    width: '100px',
                },
                {
                    id: 'serial-number',
                    name: _(React.createElement(React.Fragment, null, t('製造番号'))),
                    width: '140px',
                },
                {
                    id: 'retailer-code',
                    name: _(React.createElement(React.Fragment, null, t(is_se ? '販売店コード' : '実販売店コード'))),
                    width: '140px',
                },
                // 以下は画面に表示しないデータ（カラム）
                {
                    id: 'id',
                    hidden: true,
                },
                {
                    id: 'status',
                    hidden: true,
                },
            ], search: false, sort: true, pagination: {
                enabled: true,
                limit: display_count,
            }, fixedHeader: true, height: "600px" }))));
};
export default memo(ResultList);
